interface PlayerBoxProps {
  title: string;
  episodeLabel: string;
  cover: string;
}

export default function PlayerBox({ title, episodeLabel, cover }: PlayerBoxProps) {
  return (
    <div className="w-full">
      <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-foreground-950">
        <img
          src={cover}
          alt={`${title} 播放画面`}
          className="absolute inset-0 w-full h-full object-cover opacity-35 blur-sm"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-500 text-background-50 mb-4">
            <i className="ri-play-fill text-3xl"></i>
          </span>
          <p className="text-background-50 text-sm md:text-base font-medium">
            视频播放功能演示中，正式上线需接入播放服务
          </p>
          <p className="mt-1.5 text-xs text-background-100/70">
            {title} · {episodeLabel}
          </p>
        </div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-black/50 text-background-50 text-xs backdrop-blur-sm">
          {episodeLabel}
        </span>
      </div>
    </div>
  );
}